import Vue from 'vue';

export default {
  // 获取企业动态
  getNewsList(params) {
    return Vue.axios.get('/api/v1.0/system/news/list', {params});
  }
};
